// extracted by mini-css-extract-plugin
module.exports = {"dangerous-goods":"dangerous-goods-38bgelX","form-item-label":"form-item-label-2DP6qMw","form-item-content":"form-item-content-25IhoBL"};